import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PropertyMap from '../../../components/property-map/property-map'
import GenericPageContainer from '../../../GenericPageElements/GenericPageContainer.jsx'
import request from '../../../helpers/request'
import LinkedReferenceTable from '../../../components/linked-reference-table/LinkedReferenceTable.jsx'
import ReactModal from 'react-modal'
import hasPermission from '../../../helpers/permissions'
import {CMOSLive} from '../../../components/ap-generics/components/evidence-tables/CMOSLive'
import { AddressBase } from '../../../components/ap-generics/components/evidence-tables/AddressBase'
import { ValuationOfficeAndCouncilTax } from '../../../components/ap-generics/components/evidence-tables/ValuationOfficeAndCouncilTax'
import { CMOSFormatted } from '../../../components/ap-generics/components/evidence-tables/CMOSFormatted'
import { MDS } from '../../../components/ap-generics/components/evidence-tables/MDS'
import { ConfirmModal } from '../../../components/ap-generics/components/modals/ConfirmModal.jsx'
import useMDSData from '../../../components/ap-generics/hooks/useMDSData'
import VoaHistoryTable from '../../../components/voa-history-table/VoaHistoryTable.jsx'
import endpoints from '../../../helpers/endpoints.js'
import './PostcodeAssessment.scss'
import SpidSearchModal from '../../../components/spid-search-modal/SpidSearchModal.jsx'
import getWorkflowStatuses from '../../../helpers/getWorkflowStatuses.js'

export default function PostcodeAssessment() {
    const [postcodeSearch, setPostcodeSearch] = useState('')
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [loading, setLoading] = useState(false)
    const [summaryData, setSummaryData] = useState([])
    const [selectedMatches, setSelectedMatches] = useState({abp: '', voa: '', ct: ''})
    const [confirmModal, setConfirmModal] = useState(false)
    const {mdsData, setMdsData, getMDSData, mdsDataReady, setMdsDataReady, mdsMeterData, setMdsMeterData, customMDSPostcode, setCustomMDSPostcode} = useMDSData(summaryData[selectedIndex], prefix)
    const [cmosUserInput, setCmosUserInput] = useState({})
    const [meterUserInput, setMeterUserInput] = useState({})
    const prefix = "PORTFOLIO_SUMMARY"
    const matchCategory = "Address_Status"
    const [translations, setTranslations] = useState({})
    const [spidSearchModal, setSpidSearchModal] = useState(false)
    const [spidSearch, setSpidSearch] = useState()
    const [spidSearchLoading, setSpidSearchLoading] = useState()
    const [updateOutcomeLoading, setUpdateOutcomeLoading] = useState(false)
    const [currentBrReference, setCurrentBrReference] = useState("")
    const [notesModal, setNotesModal] = useState(false)
    const [wholesalerNotes, setWholesalerNotes] = useState('')
    const [wsNoteIndex, setWsNoteIndex] =  useState()
    const [prevWsNotes, setPrevWsNotes] =  useState([])

    useEffect(() => {
        request(true).get('/translate?key=mosl_eligibility')
        .then(e => {
            setTranslations(e.data)
        })
    }, [])

    useEffect(() => {
        setSelectedMatches({abp: '', voa: '', ct: ''})
    }, [selectedIndex])

    useEffect(() => {
        getMDSData(summaryData[selectedIndex], prefix)
        setSpidSearch(summaryData[selectedIndex]?.Core_SPID)
    }, [selectedIndex, summaryData])

    const getSummaryData = () => {
        setLoading(true)
        setMdsData({})
        setSummaryData([])
        request(true).get(endpoints[`${prefix}_POSTCODE_SEARCH`], {
            doesCancel: true,
            params: {
                postcode: postcodeSearch
            }
        }).then(r => {
            setSummaryData(r.data)
            setLoading(false)
        }).catch(e => {
            console.log(e)
            window.alert("No results found")
            setLoading(false)
        })
    }

    useEffect(() => {
        window.reloadSummaryData = getSummaryData
    }, [getSummaryData])

    const submitNotes = () =>{
        request(true).post(endpoints[`${prefix}_SUBMIT_NOTES`], {
            SPID: notesModal,
            notes: wholesalerNotes,
            noteType: "Wholesaler",
        }).then(e => {
            setWsNoteIndex(e.data.filter(note => note.Note_Type === "Wholesaler").length)
            setPrevWsNotes(e.data.filter(note => note.Note_Type === "Wholesaler"))
            setWholesalerNotes('')
            window.alert("Note submitted")
            setWsNoteIndex(0)
        }).catch(e => {
            console.log(e)
            window.alert("Update failed.")
        })
    }

    useEffect(() => {
        if (notesModal === false) {
            setWholesalerNotes('')
            setWsNoteIndex(0)
            setPrevWsNotes([])
        } else {
            const data = summaryData.find(datum => datum.Core_SPID === notesModal)
            setPrevWsNotes(data.notes)
            setWsNoteIndex(data.notes.length)
        }
    }, [notesModal])

    const outcomes = getWorkflowStatuses('MANAGED_SERVICE')

    return (
          <GenericPageContainer
          containerWidth={"92vw"}
          className={'postcode-assessment'}
          title={'Postcode Assessment'}
          titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
          titleRight={
            <div>
                <button style={{  gridColumn: 'span 2' }} className="navigate" onClick={() => setSpidSearchModal(true)}>
                    Single SPID Search
                </button>
            </div>
          }
        >
            <div className='pa-container'>
                <div style={{ display: 'grid', gap: '10px', gridTemplateColumns: `repeat(${outcomes.length}, auto)`, margin: '0em 5em' }}>
                    {
                        outcomes.map(outcome => {
                            const count = summaryData.filter(datum => datum.WS_Outcome === outcome.value).length
                            return (
                                <button disabled className={`button compact smaller-text ${summaryData[selectedIndex]?.WS_Outcome === outcome.value ? "bulk-buy-button" : "background-primary"} colour-white`} >
                                    {outcome.label} ({count ?? 0})
                                </button>
                            )
                        })
                    }
                </div>
                <div className='summary-table-container'>
                    <table className='table borders squish smaller-text left scrollable'>
                        <thead>
                            <tr>
                                <th colSpan={7}>Summary</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='postcode-row'>
                                <td>Postcode</td>
                                <td>
                                    <div className='postcode-search'>
                                        <input type='text' value={postcodeSearch || ''} onChange={(event) => setPostcodeSearch(event.target.value)} onKeyDown={(event) => {
                                            if (event.key === 'Enter') {
                                                getSummaryData()
                                            }
                                        }} />
                                        {
                                            loading && <i className="fa fa-spinner fa-spin" />
                                        }
                                        <span className='fas fa-search colour-primary' onClick={getSummaryData} />
                                    </div>
                                </td>
                                <td colSpan={5} />
                            </tr>
                            <tr className='address-headers'>
                                <td className='address-header'>{translations['SPID']}</td>
                                <td className='address-header'>{translations['CMOS_Address_Single_Line']}</td>
                                <td className='address-header'>{translations['Matched_UPRN_Single_Line']}</td>
                                <td className='address-header'>{translations['Status_UPRN']}</td>
                                <td className='address-header'>{translations['Matched_VOA_Single_Line']}</td>
                                <td className='address-header'>{translations['Status_VOA_No']}</td>
                                <td className='address-header'>{translations['Workflow_Status']}</td>
                            </tr>
                            {
                                summaryData.length > 0 ?
                                    summaryData.map((row, index) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <div className='spid-cell'>
                                                        {row['Core_SPID']}
                                                        <input 
                                                        id={`checkbox--${row.Core_SPID}`} 
                                                        type="checkbox" 
                                                        checked={ selectedIndex === index }
                                                        onChange={() => {setSelectedIndex(index)}}
                                                        style={{display: "inline", width: "unset"}}
                                                        />
                                                        <div className='edit-notes-button'
                                                            onClick={() => {
                                                                setNotesModal(row.Core_SPID)
                                                            }}
                                                        >
                                                            <i class="fa-solid fa-pen-to-square colour-primary" />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{row['CMOS_Address_Single_Line']}</td>
                                                <td>{row['Matched_UPRN_Single_Line']}</td>
                                                <td>{row['DQA_UPRN']}</td>
                                                <td>{row['Matched_VOA_Single_Line']}</td>
                                                <td>{row['DQA_VOA']}</td>
                                                <td>
                                                    <select disabled={!hasPermission(prefix, 'WHOLESALER') || !row.Core_SPID || ["Complete", "Assured", "Quality Check Passed"].includes(row.WS_Outcome) || updateOutcomeLoading } value={row.WS_Outcome ?? 'New'} 
                                                        onChange={(event) => {
                                                            const newOutcome = event.target.value;
                                                            if (["Complete", "Assured", "Reject", "Quality Check Passed"].includes(newOutcome)) {
                                                                setConfirmModal(newOutcome)
                                                            } else {
                                                                if (newOutcome === summaryData.WS_Outcome) return
                                                                setUpdateOutcomeLoading(true)
                                                                request(true).post(endpoints[`${prefix}_UPDATE_OUTCOMES`], {
                                                                    SPID: row.Core_SPID,
                                                                    WS_Outcome: newOutcome,
                                                                }).then(e => {
                                                                    // window.alert(e.data);
                                                                    const newData = summaryData.map(datum => {
                                                                        if (datum.Core_SPID === row.Core_SPID) {
                                                                            datum.WS_Outcome = newOutcome
                                                                        }
                                                                        return datum
                                                                    })
                                                                    setSummaryData(newData)
                                                                    setUpdateOutcomeLoading(false)
                                                                }).catch(e => {
                                                                    console.log(e)
                                                                    setUpdateOutcomeLoading(false)
                                                                    window.alert("Update failed.")
                                                                })
                                                            }
                                                        }} 
                                                        style={{paddingLeft: 0}}
                                                    >
                                                        <option value="New">New</option>
                                                        <option value="In Progress">In Progress</option>
                                                        <option value="Different Reference">Different Reference</option>
                                                        <option value="Address Change">Address Change</option>
                                                        <option value="Potential Split">Potential Split</option>
                                                        <option value="Potential HH">Potential HH</option>
                                                        <option value="Problem Address">Problem Address</option>
                                                        <option disabled={true} value="Reject">Reject</option>
                                                        <option disabled={summaryData[selectedIndex]?.Core_SPID !== row.Core_SPID} value="Complete">Complete</option>
                                                        <option disabled={summaryData[selectedIndex]?.Core_SPID !== row.Core_SPID} value="Assured">Assured</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        )
                                    })
                                :
                                    <tr><td/><td/><td/><td/><td/><td/><td/></tr>
                            }
                        </tbody>
                    </table>
                </div>
                <div style={{display: 'grid', gridAutoColumns: '1fr', gridAutoFlow: 'column', gap: 10}}>
                    <CMOSLive translations={translations} summaryData={summaryData[selectedIndex] ?? {}} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} />
                    <AddressBase translations={translations} summaryData={summaryData[selectedIndex] ?? {}} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} setUserInput={setCmosUserInput} />
                    <ValuationOfficeAndCouncilTax translations={translations} summaryData={summaryData[selectedIndex] ?? {}} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} setUserInput={setCmosUserInput} setCurrentBrReference={setCurrentBrReference} />
                    {/* <MeterAddress translations={translations} summaryData={summaryData[selectedIndex] ?? {}} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} userInput={meterUserInput} setUserInput={setMeterUserInput} /> */}
                    <VoaHistoryTable voaReference={currentBrReference} translations={translations} prefix={prefix}/>
                    <CMOSFormatted translations={translations} summaryData={summaryData[selectedIndex] ?? {}} setSummaryData={setSummaryData} workflow={true} selectedMatches={selectedMatches} prefix={prefix} userInput={cmosUserInput} setUserInput={setCmosUserInput} meterInput={meterUserInput} />
                </div>
                <div>
                    <ConfirmModal confirmModal={confirmModal} setConfirmModal={setConfirmModal} prefix={prefix} summaryData={summaryData[selectedIndex]} setSummaryData={setSummaryData} cmosUserInput={cmosUserInput} meterUserInput={meterUserInput} />
                </div>
                <LinkedReferenceTable summaryData={summaryData[selectedIndex] ?? {}} translations={translations} prefix={prefix} />
                <MDS data={ mdsData } MDSDataReady={ mdsDataReady } getData={ () => getMDSData(summaryData[selectedIndex], setMdsDataReady, prefix, customMDSPostcode, setMdsData, setMdsMeterData) } customPostcode={ customMDSPostcode } setCustomPostcode={ setCustomMDSPostcode } style={{ fontSize: '14px' }} classes={"squish"} SPID={summaryData[selectedIndex]?.Core_SPID} /> 
                <div style={{minHeight: '40vh', marginBottom: '10em'}}>
                <PropertyMap 
                    translations={translations} 
                    eastingNorthing={summaryData[selectedIndex] && summaryData[selectedIndex].CMOS_UPRN_GISX && summaryData[selectedIndex].CMOS_UPRN_GISY && [parseInt(summaryData[selectedIndex].CMOS_UPRN_GISX), parseInt(summaryData[selectedIndex].CMOS_UPRN_GISY)]} 
                    address={summaryData[selectedIndex]?.['CMOS_Address_Single_Line'] ?? summaryData[selectedIndex]?.['CMOS_Meter_Address_Single_Line']} 
                    uprnEastingNorthing={summaryData[selectedIndex] && summaryData[selectedIndex].Matched_UPRN_GISX && summaryData[selectedIndex].Matched_UPRN_GISY ? [parseInt(summaryData[selectedIndex].Matched_UPRN_GISX), parseInt(summaryData[selectedIndex].Matched_UPRN_GISY)] : null} 
                    meterEastingNorthing={summaryData[selectedIndex] && summaryData[selectedIndex].CMOS_Meter_GISX && summaryData[selectedIndex].CMOS_Meter_GISY  ? [parseInt(summaryData[selectedIndex].CMOS_Meter_GISX), parseInt(summaryData[selectedIndex].CMOS_Meter_GISY )] : null} 
                    displayExtraPins={true} 
                    matchedUprnText={true}
                    mdsMeterData={mdsMeterData}
                    showAllMeters={true}
                />
                </div>
                <SpidSearchModal
                    search={spidSearch} setSearch={setSpidSearch} 
                    isOpen={spidSearchModal} setIsopen={setSpidSearchModal} 
                    prefix={prefix}
                    title={'Postcode Assessment - Search'}
                    returnUrl={'/portal/postcode-assessment'} 
                    linkTitle={'To Postcode Assessment'}
                    linkTo={'/portal/postcode-assessment-search'}
                />
                <ReactModal
                    isOpen={notesModal} 
                    onRequestClose={() => setNotesModal(false)}
                    className="card bulk-allocate postcode-assessment-notes-modal"
                    contentLabel="Notes Modal"
                    style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}
                >
                    <div className='notes-modal-content'>
                        <h2>Notes for Core SPID: {notesModal}</h2>
                        <div style={{position: 'relative'}}>
                            <textarea disabled={!hasPermission(prefix, 'WHOLESALER')} value={wholesalerNotes ?? ''} rows={8} style={{height: '100%', width: '100%', resize: 'none'}} onChange={(event) => setWholesalerNotes(event.target.value.slice(0, 500))} />
                            <div style={{ position: 'relative', bottom: '3px', float: 'right', color: 'gray', fontSize: 12 }}>
                                {wholesalerNotes.length}/500
                            </div>
                            <textarea disabled={true} value={prevWsNotes[wsNoteIndex - 1]?.Note ?? ''} rows={8} style={{height: '100%', width: '100%', resize: 'none'}}/>
                            <div style={{ position: 'relative', bottom: '3px', float: 'right', color: 'gray', fontSize: 12, display: 'flex', gap: 10, alignItems: 'center' }}>
                                {wsNoteIndex ?? 0}/{prevWsNotes.length} <i class="fa-solid fa-chevron-left" style={{ cursor: wsNoteIndex !== 1 && wsNoteIndex !== 0 ? 'pointer' : 'unset' }} onClick={() => setWsNoteIndex(wsNoteIndex !== 1 && wsNoteIndex !== 0 ? wsNoteIndex - 1 : wsNoteIndex)} /> <i class="fa-solid fa-chevron-right" style={{ cursor: wsNoteIndex !== prevWsNotes.length ? 'pointer' : 'unset' }} onClick={() => setWsNoteIndex(wsNoteIndex !== prevWsNotes.length ? wsNoteIndex + 1 : wsNoteIndex)} />
                            </div>
                            <div style={{ position: 'relative', bottom: 5, left: 5, color: 'gray', fontSize: 12, display: 'flex', gap: 10, alignItems: 'center', minHeight: '3vh' }}>
                                { prevWsNotes.length > 0 ?
                                    prevWsNotes[wsNoteIndex - 1]?.User_Name + " - " + 
                                    new Date(prevWsNotes[wsNoteIndex - 1]?.Date).toLocaleString('en-GB', { timeZone: 'Europe/London', hour12: false }).replace(',', '').replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')
                                : ''}
                            </div>
                            <div className='notes-modal-buttons'>
                                <button
                                    className='button compact smaller-text reject cancel'
                                    onClick={() => {
                                        setNotesModal(false)
                                        setWholesalerNotes('')
                                        setWsNoteIndex(0)
                                    }}
                                >Cancel</button>
                                <button 
                                    disabled={(!hasPermission(prefix, 'WHOLESALER') || wholesalerNotes.length < 0 )} 
                                    className={`button compact smaller-text ${(hasPermission(prefix, 'WHOLESALER')) && wholesalerNotes.length > 0 ? 'background-primary colour-white' : ''}`}
                                    onClick={() => submitNotes('Wholesaler')}
                                >Submit Notes</button>
                            </div>
                        </div>
                    </div>
                </ReactModal>
            </div>
        </GenericPageContainer>
    )
}